<!-- PEDIDO DE VENDA

FALTA:
- codigo do item deve retornar objeto ITEM completo do servidor e agregar ao PEDVIT
- campo unidade de medida listar somente o que está relacionado ao item
- carregar a tabela de preços como parametro para a pesquisa dos itens
- se o item nao possuir preco, habilitar campo de preco para digitacao

-->

<script>
import { SysVars } from '../main';
import { arr, calcDesconto } from '../shared/numbers'
import { getText, formatValue, formatDataExtenso, formatDataHoraExtenso } from '../shared/utils'
import { apiORDS, apiORDSapp, apiORDSpost, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import PedidoAddlist from '../forms/pedido-addlist'
import PedidoAdditem from '../forms/pedido-additem'
import PedidoRentabilidade from '../forms/pedido-rentabilidade'
import PedidoFormInfcpl from './fv-pedido-form-infcpl'
import PedidoImpressao from '../forms/pedido-impressao.vue'
import CustomerForm from '../forms/customer-form'
import NatesForm from '../forms/nates-form'
import CustomerContatoForm from '../forms/customer-contato-form'
import VendForm from '../forms/vend-form'
import grade from '../components/grade'
import AnexosForm from '../components/anexos-form'
import apiPedido from '../api/api-pedido.js'

export default {
  props: {
    index: '',
    crud: '',
    negocio: { type: Object },
  },

  components: {
    PedidoAdditem, PedidoAddlist, PedidoFormInfcpl, PedidoRentabilidade, CustomerForm, NatesForm, CustomerContatoForm, grade, AnexosForm, PedidoImpressao
  },

  data() {
    return {
      crudText: '',

      view: false, //variavel para controle de visualizacao ou edicao
      formNew: false, //incluindo novo pedido
      showFormInfAd: false, //editando cabecalho
      formPar: false, //editando parcelas
      formOrder: false,
      showDescontos: false,
      aplicaDescontoItens: false,
      aplicaDescontoTotal: false,
      showFormItem: false, //exibe o formulario de manutencao de item
      showPartForm: false, //exibe o formulario de cliente para inclusao
      showVendForm: false, //exibe o formulario de vendedor para inclusao
      showNatesForm: false, //exibe o formulario de naturezas para inclusao
      showContatoForm: false, //exibe o formulario de contato do cliente para inclusao
      showFormEmail: false, //exibe o formulario para envio de email
      showFormEmailCieloSL: false, //exibe o formulario para envio de email
      showTotal: false,
      btEnviar: false,
      btImprimir: false,
      btFaturar: false,
      btCancelar: false,
      formItemView: false,
      CANCEL_ITEM_MESSAGE: false,
      DELETE_ITEM_MESSAGE: false,
      CANCEL_MESSAGE: false,
      CIELO_SL_MESSAGE: false,

      cielo_sl_link: null,

      codpedv: null,

      showListaDestaques: false,

      isValidCabec: true,

      updateItem: false, //indica quando for uma alteracao de item

      hasPriceTab: false,  //indica que possui tabela de preço e o campo preço será desabilitado

      //entidades
      pedv: { ...this.$store.getters.getEntities.pedv },
      pedvit: {},
      pedvpar: [],  //parcelas do pedido
      pedvit_update: {},
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: {},  //armazena as mensagens de validacao do pedido de venda apos a gravacao

      anexos: [], //lista de anexos do pedido
      showAnexo: false,

      itped: 0, //sequencial do item
      moreActions: [],  //botao mais acoes

      unwatch: true,

      //PEDIDOS VINCULADOS À NEGOCIOS DO CRM
      negociocrm: null,
      pessoa: null,
      organizacao: null,
      telefones: [],
      emails: [],

      partTabela: false,
      partCodTabpre: null,

      pagamentoonline: false,

      logisticaValidation: null,
      codpedvImpressao: null,
      showImpressao: false,
      showContatosWhats: false,

    }
  },

  computed: {
    botaoGerarPedido: function () {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio && !this.bloqueia_gerar_pedido
    },

    botaoPerdido: function () {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio
    },

    orcamentoVencido: function () {
      return (this.pedv.tppedv == 'O' && this.pedv.stpedv == 'P' && this.pedv.dtvalidade && (new Date(this.pedv.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)))
    },

    orcamentoCrm: function () {
      return this.negociocrm || this.pedv.codnegocio
    },

    possuiListaDestaqueValida: function () {
      if (!this.$store.getters.getDestaqList.length)
        return false
      else {
        return this.$store.getters.getDestaqList.filter(obj => { return obj.isvalid == 'S' }).length > 0
      }
    },

    showPesquisaItens: function () {
      return this.pedv.codpart && this.pedv.codnates && !this.showFormItem
    },

    select2Contato: function () {
      return { entity: 'partcontato/' + this.pedv.codpart, minlength: 0 }
    },

    administrador: function () {
      return SysVars.usuarioAdministrador
    },

    dataLeitura: function () {
      return 'O pedido foi recebido pela empresa em ' + formatDataHoraExtenso(this.pedv.data_leitura)
    },

    tagAlteracaoBloqueada: function () {
      if (!this.administrador && this.pedv.tppedv == 'P' && this.pedv.stpedv == 'P')
        return 'Alteração não permitida'
    },

    isView: function () {
      //NAO PERMITE ALTERACAO NO PEDIDO QUANDO HÁ TITULOS ENVIADOS, TITULOS BAIXADOS OU NOTA LANÇADA
      //NAO PERMITE ALTERACAO DO PEDIDO QUANDO É USUARIO COMUM, SOMENTE ORÇAMENTO
      if (!this.administrador && this.pedv.tppedv == 'P' && this.pedv.stpedv != 'P') {
        return true
      } else {
        let result = this.view || this.pedv.tppedv == 'R' || (this.pedv.stpedv != 'D' && this.pedv.stpedv != 'P') ||
          (this.pedv.fin_baixado > 0) || (this.pedv.fin_remessa > 0) || (this.pedv.nf_emitida > 0) ||
          (this.pedv.nf_pendente > 0)
        return result


      }
    },

    btTotalizar: function () {
      return !this.view && this.pedv.stpedv == 'D' && this.pedvit.length > 0
    },

    tabelas_preco_options: function () {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      let options = []

      let liberado = []
      let currTabpre = {}
      let addTabela = false


      for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
        currTabpre = this.$store.getters.getTabpreList[x]

        //se existir parametros do usuario, libera somente as tabelas permitidas
        if (this.partCodTabpre && this.partCodTabpre == currTabpre.codtabpre)
          addTabela = true
        else
          if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
            liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == currTabpre.codtabpre })
            if (liberado.length > 0) {
              addTabela = true
            }
          } else {
            addTabela = true
          }

        if (addTabela)
          options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })

        addTabela = false
      }

      return options
    },

    bloqueia_gerar_pedido: function () {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
        return this.$store.getters.getParametrosUsuario.vendas.bloqueia_gerar_pedido
      else
        return false
    },

    bloqueia_descontos: function () {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
        return this.$store.getters.getParametrosUsuario.vendas.bloqueia_descontos
      else
        return false
    },

    bloqueia_tabela_cliente: function () {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
        if (this.partTabela)
          return this.$store.getters.getParametrosUsuario.vendas.bloqueia_tabela_cliente
        else
          return false
      else
        return false
    },

    condicaoList: function () {
      return this.$store.getters.getCondicaoList
    },

    condicao_descricao: function () {
      if ((!this.pedv.codcondicao) || (!this.condicaoList))
        return ''
      else
        for (var x = 0; x < this.condicaoList.length; x++) {
          if (this.condicaoList[x].codcondicao == this.pedv.codcondicao) {
            return this.condicaoList[x].descricao
          }
        }
    },

    itemList: function () {
      return this.$store.getters.getItemSalesList
    },

    natesListSaida: function () {
      return this.$store.getters.getNatesSaidaList
    },

    codpart: function () {
      return this.pedv.codpart
    },

    part: function () {
      return this.$store.getters.getPart
    },

    selectedNates: function () {
      return this.$store.getters.getNates
    },

    codnates: function () {
      return this.pedv.codnates
    },

    prazodias: function () {
      return this.pedv.prazodias
    },

    prazo: function () {
      return this.pedv.prazo
    },

    validadedias: function () {
      return this.pedv.validadedias
    },

    dtvalidade: function () {
      return this.pedv.dtvalidade
    },

    parcelas: function () {
      return this.pedv.parcelas
    },

    title: function () {
      if (this.pedv.tppedv === 'P' && this.pedv.npedido === null) {
        return 'Incluindo Pedido'
      } else
        if (this.pedv.tppedv === 'P') {
          return 'Pedido de Venda [' + this.pedv.npedido + ']'
        } else
          if (this.pedv.ncotacao === null) {
            return 'Incluindo Orçamento'
          } else {
            return 'Orçamento [' + this.pedv.ncotacao + ']'
          }
    },

    cielo_condicao: function () {
      var r = false;

      if ((this.pedv.codcondicao > 0) && (this.pedv.filial[0] !== null)) {
        if (this.pedv.filial[0].parametros !== null) {
          var parametros = JSON.parse(this.pedv.filial[0].parametros);

          if (parametros.hasOwnProperty('pagonline') &&
            parametros.pagonline.hasOwnProperty('cielo') &&
            parametros.pagonline.cielo.hasOwnProperty('id')) {

            if (parametros.pagonline.cielo.id == this.pedv.codcondicao) {
              r = true;
            }
          }
        }
      }

      return r;
    },

    rede_condicao: function () {
      var r = false;

      if ((this.pedv.codcondicao > 0) && (this.pedv.filial[0] !== null)) {
        if (this.pedv.filial[0].parametros !== null) {
          var parametros = JSON.parse(this.pedv.filial[0].parametros);

          if (parametros.hasOwnProperty('pagonline') &&
            parametros.pagonline.hasOwnProperty('rede') &&
            parametros.pagonline.rede.hasOwnProperty('id')) {

            if (parametros.pagonline.rede.id == this.pedv.codcondicao) {
              r = true;
            }
          }
        }
      }

      return r;
    },

    pagseguro_condicao: function () {
      var r = false;

      if ((this.pedv.codcondicao > 0) && (this.pedv.filial[0] !== null)) {
        if (this.pedv.filial[0].parametros !== null) {
          var parametros = JSON.parse(this.pedv.filial[0].parametros);
          if (parametros.hasOwnProperty('pagonline') &&
            parametros.pagonline.hasOwnProperty('pagseguro') &&
            parametros.pagonline.pagseguro.hasOwnProperty('id')) {

            if (parametros.pagonline.pagseguro.id == this.pedv.codcondicao) {
              r = true;
            }
          }
        }
      }

      return r;
    },

    disableTppedv: function () {
      //desabilita o campo tipo de documento este já for pedido de venda
      return this.pedv.tppedv === 'P' && this.pedv.codpedv != null
    },

    _endereco: function () {
      if (!this.pedv.part)
        return null
      let end = this.pedv.part[0].ende
      if (end) {
        if (this.pedv.part[0].endenr)
          end = end + ', ' + this.pedv.part[0].endenr
        if (this.pedv.part[0].endecomp)
          end = end + ', ' + this.pedv.part[0].endecomp
        if (this.pedv.part[0].bairro)
          end = end + ', ' + this.pedv.part[0].bairro
        if (this._nomemun)
          end = end + ', ' + this._nomemun
        end = end + ' - ' + this.pedv.part[0].uf + ' - ' + this.pedv.part[0].cep
      }

      return end
    },

    _nomeuf: function () {
      if (this.pedv.part) {
        if (this.pedv.part[0].uf) {
          return this.pedv.part[0].uf
        } else {
          return this.pedv.part[0].estado[0].uf
        }
      }
    },

    _nomemun: function () {
      if (this.pedv.part) {
        if (this.pedv.part[0].nomemun) {
          return this.pedv.part[0].nomemun
        } else {
          return this.pedv.part[0].mun[0].nomemun
        }
      }
    },

    _cnpjcpf: function () {
      //FORMATACAO DO CNPJ DO CLIENTE
      let doc = ''
      if (this.pedv.part) {
        doc = this.pedv.part[0].cnpjcpf
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc)
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc)
      }
      return doc
    },

    _paramsPesquisa: function () {
      let params = {
        pedvit: this.pedvit,
        pedv: this.pedv
      }
      return params
    },

    _paramsDestaques: function () {
      let params = {
        pedvit: this.pedvit,
        pedv: this.pedv,
        produtosDestaque: true,
      }
      return params
    },

    appLoja: function () {
      return SysVars.appLoja
    },

    appERP: function () {
      return SysVars.appERP
    },

  },

  mixins: [apiPedido],

  filters: {
    format: function (value, decimals) {
      return formatValue(value, decimals)
    },
  },

  methods: {
    async updateImpInfGeraisGarantia(value) {

      if (this.pedv.codpedv) {
        var modulo = 'sales/pedv/' + this.pedv.codpedv + '/impinfgeraisgarantia'
        let data_json = {};
        data_json.codpedv = this.pedv.codpedv;
        data_json.impinfgeraisgarantia = value;

        const data = await apiORDSpost(this.$store, modulo, data_json, 'post')
        if (data && data.errormessage) {
          console.log(data.validacao)
          this.$erpToastError('Erro ao enviar o pedido para remessa');
        }
      }
    },

    statusColor: function (value) {
      let color = 'badge-green'
      if (value == 'C') {
        color = 'badge-red'
      } else if (value == 'D') {
        color = 'badge-orange'
      } else if (value == 'F') {
        color = 'badge-blue'
      }
      return color
    },

    handleShowDescontos(tipo) {
      this.pdesc1 = this.pedv.pdesc1
      this.pdesc2 = this.pedv.pdesc2
      this.pdesc3 = this.pedv.pdesc3
      this.pdesc4 = this.pedv.pdesc4
      this.aplicaDescontoItens = false
      this.aplicaDescontoTotal = false
      if (tipo == 'itens')
        this.aplicaDescontoItens = true
      else
        this.aplicaDescontoTotal = true
      this.showDescontos = true
    },

    handleCloseDescontos() {
      this.pedv.pdesc1 = this.pdesc1
      this.pedv.pdesc2 = this.pdesc2
      this.pedv.pdesc3 = this.pdesc3
      this.pedv.pdesc4 = this.pdesc4
      this.showDescontos = false
    },

    handleAplicaDescontos() {
      let self = this
      if (this.aplicaDescontoItens)
        this.pedv.atualiza_descontos = true
      else
        this.pedv.atualiza_descontos = false

      this.gravaPedido()
      this.showDescontos = false
      // this.apiPedido().then(function () {
      //     self.showDescontos = false
      // })
    },

    closeForm() {
      if (this.$route.params && this.$route.params.codnegocio)
        this.$router.go(-1)
      else
        if (this.$route.params && this.$route.params.id)
          this.$router.push('/pedidolist')
        else
          this.$emit('closeform')
    },

    closePartForm(id) {
      //ao fechar o formulario de inclusao de transportadoras
      if (id) this.pedv.codparttr = id
      this.showPartForm = false
    },

    closeNatesForm(id) {
      //ao fechar o formulario de inclusao de naturezas
      if (id) this.pedv.codnates = id
      this.showNatesForm = false
    },

    closeContatoForm(id) {
      //ao fechar o formulario de inclusao de vendedor
      if (id) this.pedv.seqcontato = id
      this.showContatoForm = false
    },

    closeNfForm() {
      //ao fechar o formulario de faturamento
      this.showNfForm = false
    },

    handleShowDestaque() {
      this.showListaDestaques = true
    },

    closeDestaque() {
      this.showListaDestaques = false
    },

    handleFaturar() {
      //fatura o pedido
      this.gravaPedido('pedido');

      this.$router.push('/nf/' + this.pedv.codpedv)

    },

    handleIncluir() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return
      }
      this.showPartForm = true
    },

    handleIncluirNates() {
      //exibe tela de cadastro da natureza
      if (this.isView) {
        return
      }
      this.showNatesForm = true
    },

    handleIncluirVend() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return
      }
      this.showVendForm = true
    },

    handleIncluirContato() {
      if (this.pedv.codpart == null) {
        this.$erpToastError('Selecione um cliente antes de incluir um contato.')
        return
      }
      this.showContatoForm = true
    },

    handleContinuar() {
      //BOTAO "CONTINUAR" DA TELA DE INCLUSAO DE PEDIDO
      //EFETUA A VALIDACAO DOS CAMPOS INICIAIS E ABRE OS DEMAIS DADOS DE CABECALHO
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else if (this.validacaoInicial()) {
          this.handleSaveCab()
        }
      })
    },

    handleTotalizar(close) {
      //BOTAO TOTALIZAR PEDIDO - EFETUA VALIDACOES E ENCERRA A DIGITACAO DO PEDIDO (PEDIDO PASSA PARA STATUS PENDENTE)
      if (this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.')
        return
      }

      if (this.condicaoList.length == 0)
        //campo parcelas nao pode ser preenchido quando trabalhar com cadastro de condicoes
        if (this.pedv.parcelas == null)
          this.pedv.parcelas = 0

      if (this.pedv.parcelas)
        this.calculaParcelas()

      this.pedv.stpedv = 'P'

      if (close)
        this.gravaPedido('close')
      else
        this.gravaPedido('totalizar')

      // let self = this
      // this.apiPedido().then(function () {
      //     if (self.errmessages.errmessages)
      //       return
      //     else
      //     if (close) {
      //         self.closeForm()
      //     } else {
      //         if (self.$refs.parcelas) {
      //             let elmnt = document.getElementById("condicao")
      //             elmnt.scrollIntoView() //POSICIONA NO ELEMENTO CONDICAO DE PAGAMENTO
      //             self.$refs.parcelas.focus()
      //         }
      //     }
      // })
    },

    handleGerarPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.')
        return
      }

      this.gravaPedido('gerarpedido')
      // let self = this
      // this.apiPedido('gerarpedido').then(function () {
      //     console.log(self.errmessages.errmessages)
      //     if (self.errmessages.errmessages)
      //       return
      //     else
      //     self.$erpToastSuccess('O pedido foi gerado')
      //     self.closeForm()
      // })
    },

    handleOrcamentoPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.')
        return
      }
      if (confirm("Confirma orçamento perdido?")) {
        this.gravaPedido('perdido')
        // let self = this
        // this.apiPedido('perdido').then(function () {
        //     self.$erpToastError('Orçamento perdido');
        // })
      }
    },

    async handleRemessaLogistica() {

      this.logisticaValidation = null

      var modulo = 'sales/pedv/' + this.pedv.codpedv + '/remessalogistica'

      const data = await apiORDSpost(this.$store, modulo, null, 'post')
      if (data && data.errormessage) {
        this.logisticaValidation = data.validacao
        this.$erpToastError('Erro ao enviar o pedido para remessa');
      } else
        this.loadData(this.pedv.codpedv)

    },

    handleRastreioLogistica() {

    },

    async handleEtiquetaLogistica() {
      this.logisticaValidation = null

      var modulo = 'sales/pedv/' + this.pedv.codpedv + '/etiquetalogistica'

      const data = await apiORDSpost(this.$store, modulo, null, 'post')
      if (data && data.validacao) {
        this.logisticaValidation = data.validacao
        this.$erpToastError('Erro ao imprimir etiquetas');
        return
      } else
        if (data && data.errormessage) {
          this.$erpToastError(data.errormessage);
          return
        }
      if (data.url)
        window.open(data.url, "_blank")

    },

    handleInfAdicionais() {
      //click do botao outras informacoes exibe a tela com dados para alteracao
      this.showFormInfAd = true
    },

    handleSaveCab() {
      //botao salvar dados de cabecalho
      if (this.isView) {
        return
      }
      this.gravaPedido('incluirPedido')
    },

    handleCopia() {
      //efetua a copia do pedido
      this.apiDuplica()
    },

    handleAddItem() {
      //inclusao de item individual
      if (this.isView) {
        this.$erpToastError('Não permitido')
        return
      }

      this.pedvit_update = { ...this.$store.getters.getEntities.pedvit },
        this.pedvit_update.pdesc1 = this.pedv.pdesc1
      this.pedvit_update.pdesc2 = this.pedv.pdesc2
      this.pedvit_update.pdesc3 = this.pedv.pdesc3
      this.pedvit_update.pdesc4 = this.pedv.pdesc4
      this.pedvit_update.finalidade = this.pedv.finalidade
      this.updateItem = false
      this.showFormItem = true
    },

    closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false
      this.showFormInfAd = false
      this.formOrder = true
    },

    handleSalvarItens(pedvit) {
      //efetua a inclusao de item no pedido
      if (pedvit.length == 0) {
        return
      }

      this.showFormItem = false
      this.formOrder = true

      let itens = []

      if (pedvit.length) {  //se receber uma lista de itens, ajusta a lista para efetuar gravacao
        for (var x = 0; x < pedvit.length; x++) {
          if (pedvit[x].codpedv) {
            itens.push(pedvit[x])
          } else {
            let it = { ...this.$store.getters.getEntities.pedvit }
            it.coditem = pedvit[x].coditem
            it.vlr = pedvit[x].vlr
            it.uni = pedvit[x].uni
            it.qtuni = pedvit[x].qtuni
            it.pedvgrade = pedvit[x].pedvgrade
            if (pedvit[x].tabelas_desconto)
              it.descontotab = pedvit[x].tabelas_desconto.descontos
            it.pdesc1 = pedvit[x].pdesc1
            it.pdesc2 = pedvit[x].pdesc2
            it.pdesc3 = pedvit[x].pdesc3
            it.pdesc4 = pedvit[x].pdesc4
            it.pedcliit = pedvit[x].pedcliit
            it.iskit = pedvit[x].iskit == 'S'
            itens.push(it)
          }
        }
      } else {
        itens.push(pedvit)
      }
      //EFETUA A GRAVACAO DOS ITENS NO PEDIDO
      this.gravaItens(itens)
      // this.apiItens(itens, false, false)
      this.$refs.addList.focus()

      this.closeDestaque()
    },

    handleShowGradeItem(index) {
      //EXIBE A GRADE DO ITEM NA LISTA DE ITENS
      if (this.pedvit[index].showGrade) {
        this.pedvit[index].showGrade = false
      } else {
        this.$set(this.pedvit[index], 'showGrade', true)
      }
    },

    handleEditItem(nSeq, view) {
      //EDITAR O ITEM DO PEDIDO
      this.pedvit_update = {}
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = { ...this.pedvit[x] }
        }
      }
      this.formItemView = view //indica se é alteração ou somente visualizacao
      this.updateItem = true
      this.showFormItem = true
    },

    handleItemDeleteMsg(nSeq) {
      //EXCLUI O ITEM DO PEDIDO
      this.pedvit_update = {}
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = { ...this.pedvit[x] }
        }
      }
      this.DELETE_ITEM_MESSAGE = true;
    },

    handleItemDelete(nSeq) {
      //remove o item do pedido
      this.DELETE_ITEM_MESSAGE = false;
      var pedvit = [];
      pedvit.push(this.pedvit_update)
      this.gravaItens(pedvit, false, true)
      // this.apiItens(pedvit, false, true)
    },

    handleRetorna() {
      //TRATAMENTO DO BOTAO RETORNAR (TELA DE INCLUSAO, DADOS DO PEDIDO E TELA PRINCIPAL DO PEDIDO)
      if (this.formNew) {
        //FECHA A TELA DE INCLUSAO DO PEDIDO
        this.closeForm()
      } else if (this.formOrder) {
        //FECHA A TELA DE EDICAO DO PEDIDO
        this.closeForm()
      }
    },

    async handleExcluirLinkPagamento() {
      this.pagamentoonline = false
      this.pedv.cieloidsuperlink = null;
      let self = this
      //efetua a copia do pedido
      var metodo = 'post'
      var modulo = 'sales/pedv/excluircielosuperlink'
      var sendData = { pedv: this.pedv.codpedv }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      this.cielo_sl_link = null;
      if (data) {
        if (data.link) {
          this.CIELO_SL_MESSAGE = true;
          this.cielo_sl_link = data.link;
        } else {
          this.errmessages = value;
          this.$scrollTo(0);
          this.$erpToastError(data);
        }
      }
    },

    async handleLinkPagamento(tipo) {
      this.pagamentoonline = true
      let self = this
      //efetua a copia do pedido
      var metodo = 'post'
      var modulo = 'sales/pedv/gerarcielosuperlink'
      var sendData = { pedv: this.pedv.codpedv }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      this.cielo_sl_link = null;
      if (data) {
        if (data.link) {
          if (tipo == 'whats') {
            window.open("https://wa.me/55" + data.fone + "?text=Segue link para pagamento da sua compra efetuada em nossa loja virtual " + data.link, "_blank");
          } else if (tipo == 'acessar') {
            this.CIELO_SL_MESSAGE = true;
            this.cielo_sl_link = data.link;
          } else {
            this.handleFormEmailCieloSL();
          }
        } else {
          this.errmessages = value;
          this.$scrollTo(0);
          this.$erpToastError(data);
        }
      }



    },


    //CHAMADAS API
    gravaPedido(operacao) {
      if (this.isView) {
        return
      }
      if (operacao == 'gerarpedido')
        this.pedv.tppedv = 'P'
      else
        if (operacao == 'perdido')
          this.pedv.tppedv = 'R'
        else
          if (operacao == 'cancelar')
            this.pedv.stpedv = 'C'


      this.apiPedido(operacao, this.pedv, this.pedvit, this.pedvpar, this.apiPedidoCallback)
    },

    gravaItens(pedvit, cancelItem, deleteItem) {
      //efetua a gravacao dos itens do pedido
      this.pedv.pedvit = { ...this.pedvit }
      var sendData = { pedv: this.pedv } //pega o cabecalho do pedido

      if (sendData.pedv.filial)
        delete sendData.pedv.filial

      if (pedvit.length) {
        sendData.pedv.pedvit = pedvit //adiciona os novos itens ao cabecalho
      } else {
        sendData.pedv.pedvit = []
        sendData.pedv.pedvit.push(pedvit)
      }

      this.apiItemPedido(sendData, this.updateItem, cancelItem, deleteItem, this.apiPedidoCallback)
    },

    apiPedidoCallback(operacao, pedv, validation) {
      if (validation && validation.errmessages && validation.errmessages.length) {
        this.errmessages = validation
        this.$scrollTo(0)
        this.$erpToastError('Por favor corrija os erros de validação')
      }
      else
        this.errmessages = {}

      if (pedv && pedv.stpedv == 'C') {
        this.closeForm()
        return
      }

      if (operacao == 'deleteItem') {
        this.loadData(this.pedv.codpedv)
        return
      }

      if (operacao == 'rentab') {
        this.loadData(this.pedv.codpedv)
        return
      }

      if (operacao == 'gerarpedido')
        this.closeForm()

      if (operacao == 'close') {
        this.closeForm()
      }

      this.pedv = pedv
      this.pedvit = pedv.pedvit
      this.updateActions() //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
      this.updateItem = false
      this.formNew = false

      if (operacao == 'incluirPedido') {
        if (this.errmessages.length) {
          //se retornou erros continua parado na mesma tela
        }
        else {
          this.formNew = false
          this.formOrder = true
          this.showFormInfAd = false
          this.formItemsPedido = true
        }
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })
      }

      if (operacao == 'enviaremail')
        this.handleFormEmail()

      if (operacao == 'totalizar') {
        //POSICIONA NO ELEMENTO CONDICAO DE PAGAMENTO
        if (this.$refs.parcelas) {
          let elmnt = document.getElementById("parcelas")
          elmnt.scrollIntoView()
          this.$refs.parcelas.focus()
        } else if (this.$refs.condicao) {
          let elmnt = document.getElementById("condicao")
          elmnt.scrollIntoView()
          this.$refs.condicao.focus()
        }
      }

    },

    async apiDuplica() {
      //efetua a copia do pedido
      var metodo = 'post'
      var modulo = 'sales/pedv/duplica'
      var sendData = { pedv: this.pedv.codpedv }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.items) {
        this.pedv = data.items[0]
        this.view = false
        if (this.pedv.tppedv === 'P') {
          this.$erpToastSuccess('Pedido copiado com sucesso. O novo pedido criado é: ' + this.pedv.npedido)
        } else {
          this.$erpToastSuccess('Orçamento copiado com sucesso. O novo orçamento criado é: ' + this.pedv.ncotacao)
        }
        this.errmessages = {}
        if (this.pedv.validation) {
          this.errmessages = JSON.parse(this.pedv.validation)
        }

      }
    },

    handleCancelMsg(nSeq) {
      //cancelar o pedido
      //exibe a confirmacao do cancelamento
      if (this.pedv.data_leitura) {
        this.$erpToastError('Não permitido o cancelamento de pedido com leiturada efetuada')
      }
      this.CANCEL_MESSAGE = true;
    },

    handleItemCancelMsg(nSeq) {
      //cancelar o item do pedido
      this.pedvit_update = {}
      //localiza o item para cancelar atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = { ...this.pedvit[x] }
        }
      }
      this.pedvit_update.stpedv = 'C'

      //exibe a confirmacao do cancelamento
      this.CANCEL_ITEM_MESSAGE = true;
    },

    handleItemCancel() {
      //efetiva o cancelamento do item
      this.CANCEL_ITEM_MESSAGE = false;
      var pedvit = [];
      pedvit.push(this.pedvit_update)
      this.gravaItens(pedvit, true)
      // this.apiItens(pedvit, true, false)
    },

    handleCancel() {
      //efetiva o cancelamento do pedido
      this.CANCEL_MESSAGE = false;
      this.gravaPedido('cancelar')
    },

    handleCloseMessage() {
      this.CANCEL_MESSAGE = false;
      this.CANCEL_ITEM_MESSAGE = false;
      this.DELETE_ITEM_MESSAGE = false;
      this.CIELO_SL_MESSAGE = false;
      this.cielo_sl_link = null;
    },


    handleEnviaLinkWhats(number) {
      this.showModalNumber = false
      if (!number)
        return
      else
        if (this.pedv.ecommerce == 'S') {
          let text = encodeURIComponent('Um novo status foi vinculado ao seu pedido em nossa loja virtual acesse: ' + this.link);
          window.open("https://api.whatsapp.com/send/?phone=55" + number + "&text=" + text, "_blank");
          this.closeForm();
        } else {
          this.apiEnviaPedidoWhats(this.pedv, number)
        }
    },

    handleShowContatosWhats() {
      if (!this.pedv.codpedv)
        return
      this.showContatosWhats = true
    },

    async handleWhatsapp(number) {
      // ENVIA O PEDIDO POR WHATSAPP
      this.showContatosWhats = false

      if (number)
        this.apiEnviaPedidoWhats(this.pedv, number)
    },

    handleEmail() {
      // SALVA O PEDIDO E ENVIA EMAIL
      if (this.pedv.codnegocio) {
        this.$showMessage('Orçamento vinculado a negócio', 'O envio de emails de orçamentos vinculados à negócio é permitido somente pela tela de negócio.', 'warning')
        return
      }

      if (this.isView)
        this.handleFormEmail()
      else
        this.gravaPedido('enviaremail')
    },

    handleAction(act) {
      //click do botao "mais acoes"
      if (act == 10) {
        this.handleAnexarDocumento()
      }

      if (act == 5) {
        this.apiDuplica()
      }

      if (act == 4) {
        this.handleCancelMsg()
      }

      if (act == 1) {
        this.codpedvImpressao = this.pedv.codpedv
        this.showImpressao = true
        this.$nextTick(function () {
          this.$refs.impressao.print()
        })
      }
    },
    handleClosePrint() {
      this.showImpressao = false
    },
    handleAnexarDocumento() {
      //ANEXAR DOCUMENTOS AO PEDIDO
      if (!this.showAnexo) {
        this.showAnexo = true
      }
      this.$nextTick(function () {
        this.$refs.anexos.handleClickAdiciona()
      })
    },

    handleChangeAnexos(anexosList) {
      //ATUALIZA A LISTA DE ANEXOS

      this.anexos = anexosList
    },

    handleFormEmail() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)

      this.showFormEmail = true
    },

    handleFormEmailCieloSL() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)

      this.showFormEmailCieloSL = true
    },

    closeFormEmail() {
      this.showFormEmail = false
      this.showFormEmailCieloSL = false
    },

    async handleSendEmail(data) {
      //cahamda para envio de email do pedido
      this.closeFormEmail()
      const email = await apiEmailPDF(this, 'pedv/' + this.pedv.codpedv, data)
    },

    updateActions() {
      /* ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES"
      - quando pendente permite imprimir, enviar, faturar, cancelar
      - quando em digitacao permite cancelar
      - quando liquidado ou cancelado nao permite açoes
      */
      this.btEnviar = ((this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R')
      this.btImprimir = ((this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R')
      this.btFaturar = this.pedv.stpedv == 'P' && this.pedv.tppedv == 'P' && this.pedv.ecommerce == 'S' && !(this.pedv.data_leitura)
      this.btCancelar = this.pedv.tppedv === 'P' && this.pedv.nf_pendente === 0 && this.pedv.fin_remessa === 0 && this.pedv.fin_baixado === 0

      var act = {}
      this.moreActions = []
      if (this.pedv.stpedv == 'P') {
        if (this.btCancelar) {
          act = { action: 4, label: 'Cancelar' }
          this.moreActions.push(act)
        }
      }
      if (this.pedv.tppedv === 'P') {
        act = { action: 5, label: 'Copiar Pedido' }
        this.moreActions.push(act)
      } else {
        act = { action: 5, label: 'Copiar Orçamento' }
        this.moreActions.push(act)
      }
      if (this.pedv.stpedv == 'P' || this.pedv.stpedv == 'D') {
        act = { action: 10, label: 'Anexar Documento' }
        this.moreActions.push(act)
      }

      //LIBERACAO DE RENTABILIDADE
      if (SysVars.usuarioAdministrador) {
        if (this.pedv.strentab == '1') {
          act = { action: 20, label: 'Liberar Orçamento' }
          this.moreActions.push(act)
        }
        if (this.pedv.strentab == '1') {
          act = { action: 21, label: 'Reprovar Orçamento' }
          this.moreActions.push(act)
        }
        if (this.pedv.strentab == '3' || this.pedv.strentab == '2') {
          act = { action: 22, label: 'Desfazer Liberação' }
          this.moreActions.push(act)
        }
      }
    },

    textOption(value, field) {
      var item = field.options.filter(x => x.id === value);
      var st = null
      if (item.length)
        st = item[0].text
      if (this.pedv.tppedv == 'O')
        st = 'Orçamento ' + st
      else
        st = 'Pedido ' + st
      return st
    },

    calculaTotal() {
      //calcula o total do pedido
      var t = 0
      for (var x = 0; x < this.pedvit.length; x++) {
        this.pedvit[x].totliq = this.pedvit[x].qt * this.pedvit[x].vlr
        this.pedvit[x].totliq = calcDesconto(this.pedvit[x].totliq, this.pedvit[x].pdesc1, this.pedvit[x].pdesc2, this.pedvit[x].pdesc3, this.pedvit[x].pdesc4, 2, true)
        t += this.pedvit[x].totliq
      }
      this.pedv.totliq = t
    },

    validacaoInicial() {
      //VALIDA A SITUACAO DE CREDITO DO CLIENTE, STATUS DO CLIENTE E NATUREZA DE OPERACAO
      this.isValidCabec = true

      if (this.pedv.nates && this.pedv.nates.length && this.pedv.nates[0].stnates == 'I') {
        this.$erpToastError('A Natureza de saída informada está inativa')
        this.isValidCabec = false
      }
      if (this.pedv.part[0].stcred != 'L') {
        this.$erpToastError('Cliente com crédito bloqueado')
        this.isValidCabec = false
      }
      if (this.pedv.part[0].stpart == 'I') {
        this.$erpToastError('Cliente inativo')
        this.isValidCabec = false
      }
      return this.isValidCabec
    },

    validacaoCab() {
      //validar o cliente quanto ao status do credito, status e natureza de operacao
      this.isValidCabec = true
      // if (this.pedv.parttr.length && this.pedv.parttr.stpart == 'I') {
      //     this.$erpToastError('Transportadora inativa')
      //     this.isValidCabec = false
      // }
      // if (this.pedv.vend.length && this.pedv.vend.stpart == 'I') {
      //     this.$erpToastError('Representante inativo')
      //     this.isValidCabec = false
      // }
      // if (this.pedv.tabpre.length && this.pedv.tabpre.sttabpre == 'I') {
      //     this.$erpToastError('Tabela de preço inativa')
      //     this.isValidCabec = false
      // }
      // if (this.pedv.condicao.length && this.pedv.condicao.stcondicao == 'I') {
      //     this.$erpToastError('Condição de pagamento inativa')
      //     this.isValidCabec = false
      // }
    },

    async loadData(id) {
      //carrega o pedido para alteracao ou visualizacao
      this.partTabela = false
      this.partCodTabpre = null

      this.unwatch = true
      await this.$store.dispatch('loadPedv', { id: id })
      if (this.$store.getters.getPedv) {
        this.pedv = { ...this.$store.getters.getPedv[0] }
        this.pedvit = this.pedv.pedvit
        if (this.pedv.part[0].codtabpre) {
          this.partCodTabpre = this.pedv.part[0].codtabpre
          this.partTabela = true
        }
        if (this.pedv.validation)
          this.errmessages = JSON.parse(this.pedv.validation)
        if (this.pedv.anexos.length)
          this.anexos = this.pedv.anexos
        else
          this.anexos = []
        if (this.pedv.pedvpar) {
          this.pedvpar = this.pedv.pedvpar
        }
        if (this.pedv.negociocrm && this.pedv.negociocrm.length > 0) {
          this.negociocrm = this.pedv.negociocrm[0]
          if (this.pedv.negociocrm[0].pessoa.length > 0)
            this.pessoa = this.pedv.negociocrm[0].pessoa[0]
          if (this.pedv.negociocrm[0].organizacao.length > 0)
            this.organizacao = this.pedv.negociocrm[0].organizacao[0]
        }

        this.updateActions() //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
        this.unwatch = false
      })
    },

    // changeTab (idx) {
    //     //controle de visualizacao das paginas
    //     this.formItemsPedido = true
    //     this.activeTab = idx
    // },

    calculaParcelas() {
      //CALCULA PARCELAS DO PEDIDO
      this.pedvpar = [];
      let vlr = 0
      if (this.pedv.parcelas == '0') {
        let parcela = { ...this.$store.getters.getEntities.pedvpar }
        parcela.dtv = this.pedv.data
        parcela.vlr = this.pedv.totger
        parcela.obspar = ''
        parcela.dias = 0
        this.pedvpar.push(parcela)
      } else {
        for (var x = 1; x <= this.pedv.parcelas; x++) {
          let parcela = { ...this.$store.getters.getEntities.pedvpar }
          parcela.dtv = this.$addMonths(this.pedv.data, x)
          parcela.dias = x * 30
          vlr = this.pedv.totger
          vlr = arr(vlr / this.pedv.parcelas, 2, true)
          // console.log('parcela ' + x + ': ' + vlr)
          parcela.vlr = vlr
          parcela.obspar = ''
          this.pedvpar.push(parcela)
        }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    pedvparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.pedv.parcelas <= 1) {
        return
      }
      let vlrparcial = 0
      let vlrnovaparcela = 0
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.pedvpar[x].vlr)
      }
      if (vlrparcial < this.pedv.totger) {
        vlrnovaparcela = (this.pedv.totger - vlrparcial) / (this.pedv.parcelas - (index + 1))
        vlrnovaparcela.toFixed(2)
      } else {
      }
      for (var x = index + 1; x <= this.pedvpar.length - 1; x++) {
        this.pedvpar[x].vlr = vlrnovaparcela
      }
    },

    pedvparDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dtv = this.$addDays(this.pedv.data, this.pedvpar[index].dias)
    },

    usuarioTemPermissaoNaTabelaPreco(codtabpre) {
      if (codtabpre) {
        if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
          let liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == codtabpre })
          if (liberado.length > 0) {
            return true
          }
        } else {
          return true
        }
      }
      return false
    },

    async carregaDadosCliente() {
      await this.$store.dispatch('loadPart', { id: this.pedv.codpart })
      //atualiza os dados do cliente no pedido quando informado um codigo do cliente
      if (!this.pedv.part || this.pedv.part[0].codpart != this.pedv.codpart) {
        this.pedv.part = this.part
        this.pedv.finalidade = this.pedv.part[0].tpcliente
        if (this.pedv.part[0].codnates)
          this.pedv.codnates = this.pedv.part[0].codnates
        this.pedv.nates = this.pedv.part[0].nates[0]

        this.partCodTabpre = null
        this.partTabela = false
        if (this.usuarioTemPermissaoNaTabelaPreco(this.pedv.part[0].codtabpre)) {
          this.pedv.codtabpre = this.pedv.part[0].codtabpre
          this.partCodTabpre = this.pedv.part[0].codtabpre
          this.partTabela = true
        }
        this.pedv.tabpre = this.pedv.part[0].tabpre[0]
        this.pedv.codparttr = this.pedv.part[0].codparttr
        this.pedv.parttr = this.pedv.part[0].parttr[0]
        this.pedv.codnatfin = this.pedv.part[0].codnatfinrec
        this.pedv.codcondicao = this.pedv.part[0].codcondicao
        this.pedv.condicao = this.pedv.part[0].condicao[0]
        if (this.pedv.part[0].partcontato.length > 0)
          this.pedv.seqcontato = this.pedv.part[0].partcontato[0].seqcontato
        if (this.pedv.part[0].tpfrete)
          this.pedv.tpfrete = this.pedv.part[0].tpfrete
      }
      this.validacaoInicial()
    },

    async loadNegocio(codnegocio) {
      await this.$store.dispatch('loadNegocio', { id: codnegocio })
      if (this.$store.getters.getNegocio) {
        this.negociocrm = { ...this.$store.getters.getNegocio }
        if (this.negociocrm.organizacao.length > 0)
          this.organizacao = this.negociocrm.organizacao[0]
        if (this.negociocrm.pessoa.length > 0)
          this.pessoa = this.negociocrm.pessoa[0]
        this.pedv.codnegocio = this.negociocrm.codnegocio
        this.pedv.codpart = this.organizacao.codpart
      }
    },

  },

  watch: {
    part: function () {

    },

    selectedNates: function () {
      //atualiza a natureza de operacao
      this.pedv.nates = { ...this.selectedNates }
    },

    codpart: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.carregaDadosCliente()
      }
    },

    codnates: function () {
      //carrega os dados da natureza selecionada pelo codigo => /cg/nates/id
      this.$store.dispatch('loadNates', { id: this.pedv.codnates })
    },

    prazodias: function () {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return
      if (this.pedv.prazodias > 0) {
        this.pedv.prazo = this.$addDays(this.pedv.data, this.pedv.prazodias)
      }
    },

    prazo: function () {
      //console.log(this.pedv.prazo)
    },

    validadedias: function () {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return
      if (this.pedv.validadedias > 0) {
        this.pedv.dtvalidade = this.$addDays(this.pedv.data, this.pedv.validadedias)
      }
    },

    dtvalidade: function () {
      //console.log(this.pedv.dtvalidade)
    },


    parcelas: function () {
      //calcula numero de parcelas da condicao de pagamento
      if (this.unwatch) return
      this.calculaParcelas()
    },
  },

  created() {
    //this.$store.dispatch('clearItemSales')

    //carrega parametros do usuario para bloqueio das tabelas de precos
    this.$store.dispatch('loadParametrosUsuario')

    //carrega as tabelas de precos liberadas para o usuario no computed "tabelas_preco_options"
    this.$store.dispatch('loadTabpre', {})

    this.$store.dispatch('loadNates', {})

    //carrega as condicoes de pagamento
    this.$store.dispatch('loadCondicao', {})

    //carrega lista de destaques
    this.$store.dispatch('loadDestaq', {})

    this.metadata.pedv.parcelas.options.sort(function (a, b) { return (Number(a.id) > Number(b.id)) ? 1 : ((Number(b.id) > Number(a.id)) ? -1 : 0); })

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    //this.crud = SysVars.crudI;
    this.crudText = this.$crudText(this.crud)
    this.codpedv = this.index

    this.$scrollTo(0)

    this.view = this.crud == SysVars.crudView

    let incluir = this.crud == SysVars.crudI
    if (this.$route.params && this.$route.params.id == 'novo') {
      incluir = true
      if (this.$route.params.codpart) {
        this.pedv.codpart = this.$route.params.codpart
      }
    }

    //SE A CHAMADA É DE DENTRO DO FORMULARIO DE NEGOCIO DO CRM
    //a rota chamada é /crm/negocio/:codnegocio/orcamento/novo
    if (this.$route.params && this.$route.params.codnegocio) {
      this.loadNegocio(this.$route.params.codnegocio)
      if (this.$route.params.id && this.$route.params.id != 'novo') {
        incluir = false
        this.codpedv = this.$route.params.id
      } else
        incluir = true
    }

    if (incluir) {
      this.formNew = true
      this.pedv.data = this.$getDate()
      this.pedv.stpedv = 'D'
      this.pedv.finalidade = 'F'
      this.pedv.indpresencial = '0'
      this.pedv.bonif = 'N'
      this.pedv.amostra = 'N'
      this.pedv.pgantecipado = 'N'
      this.pedv.tpfrete = '0'
      this.pedv.tppedv = 'O'
      this.pedv.impinfgeraisgarantia = 'S'
      if (this.tabelas_preco_options && this.tabelas_preco_options.length > 0) {
        this.pedv.codtabpre = this.tabelas_preco_options[0].id;
      } else {
        this.pedv.codtabpre = '1'
      }
      if (this.natesListSaida && this.natesListSaida.length > 0) {
        this.pedv.codnates = this.natesListSaida[0].codnates;
      } else {
        this.pedv.codnates = '1'
      }

      if (this.negocio) {
        this.negociocrm = this.negocio
        if (this.negociocrm.organizacao.length > 0)
          this.organizacao = this.negociocrm.organizacao[0]
        if (this.negociocrm.pessoa.length > 0)
          this.pessoa = this.negociocrm.pessoa[0]
        this.pedv.codnegocio = this.negocio.codnegocio
        if (this.organizacao)
          this.pedv.codpart = this.organizacao.codpart
      }

      this.unwatch = false
      this.updateActions()
      this.$nextTick(function () {
        this.$refs.part.focus()
      })
    } else {
      this.formOrder = true
      this.loadData(this.codpedv)
    }

  }

}

</script>

<template>
  <!-- data-toggle="tooltip" data-placement="top" title="Alterar" -->

  <div>
    <!-- FORMULARIO PRINCIPAL DO PEDIDO/ORCAMENTO  -->
    <div class="default-container mb-2" id="formOrder">
      <div class="row mb-2">
        <div class="col-md-6 col-12">
          <h4 class="def-title"> {{ title }} </h4>
        </div>
        <div class="col-md-6 col-12">
          <div class="float-right">
            <v-button label="Retornar" title="" icon="fa-arrow-left" @click="handleRetorna()"></v-button>
            <v-button v-if="btTotalizar" label="Finalizar Digitação de Produtos" :nb-btdef="true"
              title="Efetua a totalização do pedido e encerra a digitação" @click="handleTotalizar()"></v-button>
            <v-button label="" icon="fa-whatsapp" v-show="btImprimir" title="Enviar o pedido por whatsapp"
              @click="handleShowContatosWhats"></v-button>
            <v-button title="Visualizar" icon="fa-print" v-show="btImprimir" @click="handleAction(1)"></v-button>
            <v-button title="Enviar Email" icon="fa-envelope-open" v-show="btEnviar" @click="handleEmail()"></v-button>
            <v-button v-if="moreActions.length > 0" :actions="moreActions" @click="handleAction"></v-button>
          </div>
        </div>
        <div class="col-md-12 col-12" v-if="pedv.codpedv !== null">
          <span class="lbl-list pr-3"><i class="fa fa-user mr-2"></i>Proprietário {{ pedv.usuario_nome }} </span>
          <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Criado em {{ pedv.data |
              formatDataExtenso
          }}</span>
          <span v-if="pedv.data_leitura" class="badge badge-yellow mr-2" data-toggle="tooltip" data-placement="top"
            :title="dataLeitura">Leitura Efetuada</span>
          <span v-if="tagAlteracaoBloqueada" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top"
            title="Alteração não permitida em pedidos com leitura efetuada"> {{ tagAlteracaoBloqueada }} </span>
          <span v-if="pedv.tppedv == 'P'" class="badge" :class="statusColor(pedv.stpedv)">{{ textOption(pedv.stpedv,
              metadata.pedv.stpedv)
          }}</span>
          <span v-if="pedv.tppedv == 'R'" class="badge badge-red">Orçamento Perdido</span>
          <span v-if="pedv.nf_pendente" class="badge badge-red"><strong>Pedido com nota fiscal pendente</strong></span>
          <span v-if="pedv.fin_baixado" class="badge badge-yellow">Pedido com título recebido</span>
          <span v-if="pedv.fin_remessa" class="badge badge-yellow">Título enviado em remessa bancaria</span>
          <span v-if="pedv.status" class="badge badge-blue"> {{ pedv.status }} </span>
          <span v-if="pedv.ecommerce == 'S' && pedv.clienteretira == 'S'" class="badge badge-info"><i
              class="fa fa-truck mr-2" aria-hidden="true"></i> Retirar no local</span>
          <span v-if="pedv.ecommerce == 'S' && pedv.clienteretira == 'N' && pedv.descricaofrete"
            class="badge badge-info"><i class="fa fa-truck mr-2" aria-hidden="true"></i> {{ pedv.descricaofrete
            }}</span>
          <span v-if="orcamentoVencido" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top"
            title="Orçamento com data de validade vencida"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>
            Vencido</span>
        </div>
      </div>

      <!-- DADOS DO NEGOCIO CRM -->
      <div v-if="orcamentoCrm" class="row">
        <!-- NEGOCIO -->
        <div class="col-12 mb-3">
          <v-label class="w-100" :metadata-field="metadata.negociocrm.titulo"></v-label>
          <div class="w-100">
            <span class="lbl-title-produto pr-2" @click="handleShowNegocio(negociocrm.codnegocio)"> {{ negociocrm.titulo
            }} </span>
          </div>
        </div>
        <!-- ORGANIZACAO -->
        <div class="col-12 mb-3">
          <v-label class="w-100" :metadata-field="metadata.negociocrm.codorg"></v-label>
          <div v-if="organizacao" class="w-100">
            <span class="lbl-title-produto pr-2" @click="handleShowOrg(negociocrm.codorg)"> {{ organizacao.nome }}
            </span>
          </div>
          <div v-else class="w-100">
            <span class="lbl-title-produto pr-2"> Nenhuma organização vinculada </span>
          </div>
        </div>
        <!-- CONTATO -->
        <div class="col-12">
          <v-label class="w-100" :metadata-field="metadata.negociocrm.codpessoa"></v-label>
          <div v-if="pessoa" class="w-100">
            <span class="lbl-title-produto pr-2" @click="handleShowPessoa(pessoa.codpessoa)"> {{ pessoa.nome }} </span>
          </div>
          <div v-else class="w-100">
            <span class="lbl-title-produto pr-2"> Nenhum contato vinculado </span>
          </div>
          <div v-if="pessoa">
            <div class="row align-items-center" v-for="(fone, index) in pessoa.telefones" :key="index">
              <div class="col-md-12">
                <i class="fa fa-phone pr-2" aria-hidden="true"></i>
                <span class="data-list"> {{ fone.numero | formatFone }} </span>
                <span class="data-list"> {{ fone.tipofone | getTextOption(metadata.fonecrm.tipofone) }} </span>
              </div>
            </div>
          </div>
          <div v-if="pessoa">
            <div class="row align-items-center mb-1" v-for="(email, index) in pessoa.emails" :key="index">
              <div class="col-md-12">
                <i class="fa fa-envelope pr-2" aria-hidden="true"></i>
                <span class="data-list"> {{ email.email }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- INCLUSAO DO PEDIDO -->
      <div v-show="formNew && !orcamentoCrm">
        <label-title class="mb-2" title="Cliente" icon="fa-university"></label-title>
        <div class="row mb-3">
          <div class="col">
            <input-part ref="part" v-model="pedv.codpart" :add-button="true"></input-part>
          </div>
        </div>
        <div class="row">
          <form-field v-model="pedv.seqcontato" type="select2" col="6" :metadata="metadata.pedv.seqcontato"
            :disabled="isView" name="seqcontato" :v-errors="errors" v-validate="metadata.pedv.seqcontato.validator"
            :select2="select2Contato" :add-button="true" @clickAdd="handleIncluirContato()"></form-field>
        </div>
        <div class="row">
          <form-field v-model="pedv.finalidade" type="select" col="3" :metadata="metadata.pedv.finalidade"></form-field>
          <form-field v-model="pedv.pedcli" type="text" col="3" :metadata="metadata.pedv.pedcli" name="pedcli"
            :v-errors="errors" v-validate="metadata.pedv.pedcli.validator"></form-field>
        </div>
      </div>

      <div v-show="formNew">
        <div class="row" v-if="bloqueia_tabela_cliente">
          <div class="col-md-4 col-6 mb-2">
            <v-label class="w-100" :metadata-field="metadata.pedv.codtabpre"></v-label>
            <div class="lbl" v-if="pedv.tabpre">{{ pedv.tabpre.descricao }}</div>
          </div>
        </div>
        <div class="row" v-else>
          <form-field v-model="pedv.codtabpre" type="select" col="3" :metadata="metadata.pedv.codtabpre"
            :select-options="tabelas_preco_options" name="codtabpre" :v-errors="errors"
            v-validate="metadata.pedv.codtabpre.validator"></form-field>
        </div>
        <div class="row">
          <form-field v-model="pedv.tpfrete" type="select" col="3" :metadata="metadata.pedv.tpfrete" :disabled="isView">
          </form-field>
          <form-field v-model="pedv.codparttr" type="select2" col="3" :metadata="metadata.pedv.codparttr"
            :disabled="isView" name="codparttr" :v-errors="errors" v-validate="metadata.pedv.codparttr.validator"
            :add-button="true" @clickAdd="handleIncluir"></form-field>
        </div>
      </div>
      <!-- FIM INCLUSAO DO PEDIDO -->



      <!-- ALTERACAO DO PEDIDO -->
      <div v-if="pedv.codpedv !== null">
        <label-title v-if="!orcamentoCrm" title="Cliente" icon="fa-university"></label-title>
        <div class="row">
          <div v-if="!orcamentoCrm" class="col-12 col-md-6 mb-2">
            <input-part ref="part" :seqcontato="pedv.seqcontato" :disabled="true" v-model="pedv.codpart"></input-part>
          </div>
          <div class="col-12 col-md-6">
            <input-switch type="success" label="Imprimir Informações Gerais e Garantia dos Produtos"
              v-model="pedv.impinfgeraisgarantia" value-checked="S" value-unchecked="N"
              @input="updateImpInfGeraisGarantia"></input-switch>
          </div>


          <div class="col-12">
            <label-title v-if="anexos.length > 0" title="Anexos" icon="fa-paperclip"></label-title>
            <anexos-form v-if="anexos.length > 0 || showAnexo" ref="anexos"
              :params="{ ref: 'pedv', chaveref: pedv.codpedv, showForm: false }" @change="handleChangeAnexos">
            </anexos-form>
          </div>

        </div>
      </div>

      <!-- MENSAGENS DE VALIDACAO -->
      <div class="row" v-if="errmessages && errmessages.errmessages">
        <div class="col-md-12">
          <label-title title="Erros de Validação" icon="fa-check-circle"></label-title>
        </div>
      </div>
      <validation v-if="errmessages" title="Erros de Validação" :messages="errmessages.errmessages"></validation>
      <!-- FIM MENSAGENS DE VALIDACAO -->

      <pedido-rentabilidade v-if="pedv" :pedv="pedv" @reload="loadData(pedv.codpedv)"></pedido-rentabilidade>

    </div>

    <!-- ITENS DO PEDIDO -->
    <div class="default-container mb-2" style="border-top: 3px solid black">
      <div class="">
        <label-title title="Produtos" icon="fa-archive"></label-title>


        <!-- TELA DE PESQUISA DE ITENS PARA INCLUSAO NO PEDIDO -->
        <pedido-addlist ref="addList" v-if="!isView && showPesquisaItens" :params="_paramsPesquisa"
          @closeform="closeFormItem" @additem="handleSalvarItens"></pedido-addlist>
        <!-- FIM TELA DE PESQUISA DE ITENS PARA INCLUSAO NO PEDIDO -->


        <!-- BOTAO DE PRODUTOS EM DESTAQUE -->
        <div class="row col mb-2">
          <v-button v-if="!isView && possuiListaDestaqueValida" label="Lista de Destaques"
            title="Visualizar lista de produtos em destaque" icon="fa-tags" @click="handleShowDestaque"></v-button>
          <v-button class="float-right" v-if="!bloqueia_descontos && !showDescontos" :disabled="isView"
            label="Aplicar Desconto Sobre Desconto" title="Aplicar descontos escalonados em todos os itens"
            @click="handleShowDescontos('itens')"></v-button>
          <v-button class="float-right" v-if="!bloqueia_descontos && !showDescontos" :disabled="isView"
            label="Aplicar Desconto em Valor" title="Aplicar desconto no total do pedido"
            @click="handleShowDescontos('total')"></v-button>
        </div>

        <pedido-addlist v-if="!isView && showListaDestaques" :params="_paramsDestaques" @closeform="closeDestaque"
          @additem="handleSalvarItens"></pedido-addlist>
        <!-- FIM BOTAO DE PRODUTOS EM DESTAQUE -->

        <div class="p-3 border" v-if="showDescontos">
          <label-title v-if="aplicaDescontoItens" title="Descontos Sobre Desconto" icon=""></label-title>
          <div class="row" v-if="aplicaDescontoItens">
            <div class="col-12 mb-2">
              Os descontos informados aqui serão substituídos nos itens
            </div>
            <form-field v-model="pedv.pdesc1" type="value" col="2" :metadata="metadata.pedv.pdesc1" :precision="2"
              addon="%" name="pdesc1" :v-errors="errors" v-validate="metadata.pedv.pdesc1.validator"></form-field>
            <form-field v-model="pedv.pdesc2" type="value" col="2" :metadata="metadata.pedv.pdesc2" :precision="2"
              addon="%" name="pdesc2" :v-errors="errors" v-validate="metadata.pedv.pdesc2.validator"></form-field>
            <form-field v-model="pedv.pdesc3" type="value" col="2" :metadata="metadata.pedv.pdesc3" :precision="2"
              addon="%" name="pdesc3" :v-errors="errors" v-validate="metadata.pedv.pdesc3.validator"></form-field>
            <form-field v-model="pedv.pdesc4" type="value" col="2" :metadata="metadata.pedv.pdesc4" :precision="2"
              addon="%" name="pdesc4" :v-errors="errors" v-validate="metadata.pedv.pdesc4.validator"></form-field>
          </div>
          <label-title v-if="aplicaDescontoTotal" title="Desconto no total" icon=""></label-title>
          <div class="row" v-if="aplicaDescontoTotal">
            <form-field v-model="pedv.vlrdesc" type="value" col="2" :precision="2" preaddon="R$" name="vlrdesc"
              :v-errors="errors" v-validate="metadata.pedv.vlrdesc.validator"></form-field>
          </div>
          <div class="row">
            <div class="col-md-12">
              <v-button label="Confirmar" :nb-btdef="true" title="Aplicar os descontos informados em todos os itens"
                @click="handleAplicaDescontos"></v-button>
              <v-button label="Descartar" @click="handleCloseDescontos"></v-button>
            </div>
          </div>

        </div>

        <div v-if="pedvit.length == 0">
          <alert type="warning" text="O pedido ainda não possui produtos."></alert>
        </div>
        <div class="mainbox" v-for="(it, index) in pedvit" :key="index">
          <div class="mark-green"></div>
          <div class="box">
            <div class="row">
              <div class="col-md-1 col-2 text-center d-flex align-items-center">
                <img v-if="it.item[0].url" :src="it.item[0].url" class="m-auto" alt="Logotipo"
                  style="max-width: 55px; max-height: 55px; cursor: pointer;">
                <i v-else class="fa fa-camera m-auto" style="font-size: 25px; color: silver"></i>
              </div>
              <div class="col-md-4 col-10">
                <span class="lbl-list-produto w-100">{{ it.item[0].descricao }}</span>
                <v-label label="Codigo"></v-label>
                <span class="lbl">{{ it.item[0].codigo }}</span>
                <v-button v-if="it.pedvgrade && it.pedvgrade.length > 0" title="Exibir grade" icon="fa-th"
                  @click="handleShowGradeItem(index)"></v-button>
                <!-- <span v-if="it.stpedv!='D'" class="float-right badge" :class="statusColor(it.stpedv)">{{ textOption(it.stpedv, metadata.pedvit.stpedv) }}</span> -->
                <div class="w-100"></div>
                <span v-if="it.faltaestoque == 'S'" class="error">Produto não possui estoque suficiente.</span>
              </div>
              <div class="col-md-2 col-4">
                <v-label label="Quantidade x Preço"></v-label>
                <span class="lbl">{{ it.qtuni }} {{ it.uni }} x <small>R$</small> {{ it.vlr | format(2) }}</span>
                <!-- <v-label label="Impostos"></v-label> -->
                <div class="w-100"></div>
                <span class="lbl" v-if="it.aipi"><small>IPI</small> {{ it.aipi }}%</span>
                <span class="lbl" v-if="it.vicmst"><small>ICM ST R$</small> {{ it.vicmst | format(2) }}</span>
              </div>
              <!-- <div class="col-md-2 col-4">
                                <v-label :metadata-field="metadata.pedvit.qtuni"></v-label>
                                <span class="lbl">{{ it.qtuni }} {{ it.uni }} </span>
                            </div>
                            <div class="col-md-1 col-4">
                                <v-label label="Preço"></v-label>
                                <span class="lbl"><small>R$</small> {{ it.vlr | format(2) }}</span>
                            </div> -->
              <div class="col-md-2 col-4" v-if="it.qt != it.qtuni">
                <v-label :metadata-field="metadata.pedvit.qt"></v-label>
                <span class="lbl">{{ it.qt }}</span>
              </div>
              <div class="col-md-2 col-4">
                <v-label label="Desconto" class="d-block"></v-label>
                <span class="lbl">{{ it.ptotdes | format(2) }}%</span>
                <span class="lbl">(<small>R$</small> {{ it.totdes | format(2) }})</span>
              </div>
              <div class="col-md-1 col-4">
                <v-label label="Total"></v-label>
                <span class="lbl"><small>R$</small> {{ it.totger | format(2) }}</span>
              </div>
              <!-- <div class="col-md-1 col-4">
                                <v-label label="Impostos"></v-label>
                                <span class="lbl w-100"><small>IPI</small> {{ it.aipi }}%</span>
                                <span class="lbl"><small>ST R$</small> {{ it.vicmst | format(2) }}</span>
                            </div> -->
              <div class="col-md-2 col-12" v-show="it.stpedv == 'D' || it.stpedv == 'P'">
                <bar-grid :options="{ barPedvIt: true, stpedv: it.stpedv, isView: isView }" :moreActions="{}"
                  @edit="handleEditItem(it.itped, false)" @view="handleEditItem(it.itped, true)"
                  @cancel="handleItemCancelMsg(it.itped)" @delete="handleItemDeleteMsg(it.itped)" @action="closeForm()">
                </bar-grid>
              </div>
              <div class="col" v-if="it.showGrade">
                <grade ref="grade"
                  :params="{ view: true, coditem: it.coditem, qt: it.qtuni, listItemGrade: it.pedvgrade }">
                </grade>
              </div>
            </div>
          </div>
        </div>
        <br>

        <!-- TOTAL DO PEDIDO -->
        <div id="formTotal" v-show="formOrder">
          <!-- <div v-show="pedv.stpedv != 'D'"> -->
          <div v-show="pedvit.length > 0">
            <div class="row">
              <div class="ml-auto col-md-3 col-6">
                <v-label class="" :metadata-field="metadata.pedv.totmer"></v-label>
                <span class="lbl float-right">R$ {{ pedv.totmer | format(2) }}</span>
                <v-label v-if="pedv.ptotdes > 0" class="" :metadata-field="metadata.pedv.ptotdes"></v-label>
                <span v-if="pedv.ptotdes > 0" class="lbl float-right">{{ pedv.ptotdes | format(2) }}%</span>
                <div class="w-100"></div>
                <v-label v-if="pedv.vlrdesc > 0" class="" :metadata-field="metadata.pedv.vlrdesc"></v-label>
                <span v-if="pedv.vlrdesc > 0" class="lbl float-right">{{ pedv.vlrdesc | format(2) }}</span>
                <v-label :metadata-field="metadata.pedv.totdes"></v-label>
                <span class="lbl float-right">R$ {{ pedv.totdes | format(2) }}</span>
                <v-label class="" :metadata-field="metadata.pedv.rentab"></v-label>
                <span class="lbl float-right">{{ pedv.rentab | format(2) }}%</span>
              </div>
              <div class="col-md-3 col-6">
                <v-label :metadata-field="metadata.pedv.toticm"></v-label>
                <span class="lbl float-right">R$ {{ pedv.toticm | format(2) }}</span>
                <div class="w-100"></div>
                <v-label :metadata-field="metadata.pedv.toticmst"></v-label>
                <span class="lbl float-right">R$ {{ pedv.toticmst | format(2) }}</span>
                <div class="w-100"></div>
                <v-label :metadata-field="metadata.pedv.totipi"></v-label>
                <span class="lbl float-right">R$ {{ pedv.totipi | format(2) }}</span>
                <div class="w-100"></div>
                <v-label :metadata-field="metadata.pedv.vlrfre"></v-label>
                <span class="lbl float-right">R$ {{ pedv.vlrfre | format(2) }}</span>
              </div>
              <div class="col-md-2 col-12">
                <v-label class="float-right" :metadata-field="metadata.pedv.totger"></v-label><br>
                <span class="lbl-total-documento float-right">R$ {{ pedv.totger | format(2) }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-show="!formNew" class="default-container mb-2" style="border-top: 3px solid black">
      <div class="mt-2" id="condicao">
        <label-title title="Condição de Pagamento" icon="fa-credit-card"></label-title><br>
        <div class="row">
          <div class="col-md-12 col-12">
            <div class="row">
              <form-field ref="condicao" v-if="condicaoList.length > 0" v-model="pedv.codcondicao" type="select2"
                col="4" :metadata="metadata.pedv.codcondicao" :disabled="isView" name="codcondicao" :v-errors="errors"
                v-validate="metadata.pedv.codcondicao.validator"></form-field>

              <form-field v-if="appERP" v-model="pedv.codnatfin" type="select2" col="4"
                :metadata="metadata.pedv.codnatfin" :disabled="isView"
                :select2="{ entity: 'natfin/receitas/', minlength: 0 }" name="codnatfin" :v-errors="errors"
                v-validate="metadata.pedv.codnatfin.validator"></form-field>

              <form-field ref="parcelas" v-if="condicaoList.length == 0" v-model="pedv.parcelas" type="select" col="2"
                :metadata="metadata.pedv.parcelas" :disabled="isView"></form-field>

              <div class="col-md-10 col-12" v-if="pedv.parcelas > '0'">
                <div class="row justify-content-md-center">
                  <div class="col-md-2 col-3">
                    <v-label :metadata-field="metadata.pedvpar.dias"></v-label>
                  </div>
                  <div class="col-md-2 col-3">
                    <v-label :metadata-field="metadata.pedvpar.dtv"></v-label>
                  </div>
                  <div class="col-md-2 col-3">
                    <v-label :metadata-field="metadata.pedvpar.vlr"></v-label>
                  </div>
                  <div class="col-md-2 col-3">
                    <v-label :metadata-field="metadata.pedvpar.obspar"></v-label>
                  </div>
                </div>
                <div class="row justify-content-md-center" v-for="(par, index) in pedvpar" :key="index">
                  <form-field v-model="par.dias" type="number" col="2" :disabled="isView" name="dias" :v-errors="errors"
                    v-validate="metadata.pedvpar.dias.validator" @input="pedvparDiasChange(index)"></form-field>
                  <form-field v-model="par.dtv" type="date" col="2" :disabled="isView" name="dtv" :v-errors="errors"
                    v-validate="metadata.pedvpar.dtv.validator"></form-field>
                  <form-field v-model="par.vlr" type="value" col="2" :precision="2" :disabled="isView" name="vlr"
                    :v-errors="errors" v-validate="metadata.pedvpar.vlr.validator" @input="pedvparVlrChange(index)">
                  </form-field>
                  <form-field v-model="par.obs" type="text" col="2" :disabled="isView" name="obs"></form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-3" v-if="(pedv.tppedv == 'P') && (cielo_condicao || rede_condicao || pagseguro_condicao)">
        <div class="row">
          <div class="col-12">
            <label-title title="Pagamento On-line" icon="fa-credit-card"></label-title>
          </div>
        </div>
        <div class="row" v-if="pedv.vendarecebida == 'S'">
          <div class="col-12">
            <span class="badge badge-success mr-2"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento
              Efetuado </span>
          </div>
        </div>
        <div class="row" v-if="cielo_condicao">
          <div class="col-12">
            <v-button v-if="pedv.cieloidsuperlink && pedv.vendarecebida != 'S'" label="Excluir Link Pagamento"
              title="Excluir Link Pagamento" icon="fa-trash" @click="handleExcluirLinkPagamento()"></v-button>
            <v-button label="Requisitar Pagamento" title="Requisitar pagamento em cartão" icon="fa-envelope"
              @click="handleLinkPagamento()"></v-button>
            <v-button label="Requisitar Pagamento" title="Requisitar pagamento em cartão" icon="fa-whatsapp"
              @click="handleLinkPagamento('whats')"></v-button>
            <v-button label="Link de pagamento" title="" icon="fa-external-link"
              @click="handleLinkPagamento('acessar')"></v-button>
            <span v-if="pedv.cieloidsuperlink && pedv.vendarecebida != 'S' && pedv.vendarecebida != 'N'"
              class="float-right badge badge-warning mr-2"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i>
              Solicitação de pagamento gerada </span>
            <span v-if="pedv.cieloidsuperlink && pedv.vendarecebida == 'N'"
              class="float-right badge badge-warning mr-2">
              <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento Não realizado </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <label-title title="Retorno da Operadora de Pagamento On-line" icon="fa-credit-card"></label-title>
            <div v-if="pedv.pedvcielosl && pedv.pedvcielosl.length == 0">
              <alert type="warning" text="O pedido ainda não possui retornos da operadora de cartão."></alert>
            </div>
            <div class="mainbox" v-for="(it, index) in pedv.pedvcielosl" :key="index">
              <div class="box">
                <div class="row">
                  <div class="col-md-4 col-4">
                    <v-label label="Data"></v-label>
                    <span class="lbl">{{ it.data | formatDataHoraExtenso }}</span>
                  </div>
                  <div class="col-md-4 col-4">
                    <v-label label="Status"></v-label>
                    <span class="lbl">{{ it.status }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <div v-show="!formNew" class="default-container mb-2" style="border-top: 3px solid black">

      <!-- FRETE -->
      <label-title title="Integração Logística/Frete" icon="fa-truck" v-if="pedv.logistica == '1'"></label-title>
      <div class="row" v-if="pedv.logistica == '1'">
        <div class="col-md-2 col-3 text-center">
          <img src="melhorenvio.png" class="d-block" alt="Melhorenvio">
          <span v-if="pedv.remessalogistica == 'S'" class="badge badge-yellow mr-2" data-toggle="tooltip"
            data-placement="top" title="Remessa Enviada">Remessa Enviada</span>
        </div>
        <div class="col-md-2 col-3" v-if="pedv.remessalogistica == 'N'">
          <v-button label="Enviar Remessa" title="" @click="handleRemessaLogistica"></v-button>
        </div>
        <div class="col-md-2 col-3" v-else>
          <v-button label="Imprimir Etiquetas" title="" @click="handleEtiquetaLogistica"></v-button>
          <!-- <v-button label="Rastrear Objetos" title="" @click="handleRastreioLogistica"></v-button> -->
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.codfrete"></v-label>
          <div class="lbl">{{ pedv.descricaofrete }}</div>
        </div>
        <div class="col-md-12">
          <!-- MENSAGENS DE VALIDACAO -->
          <validation v-if="logisticaValidation" class="mt-3" title="Erros de Validação"
            :messages="logisticaValidation">
          </validation>
          <!-- FIM MENSAGENS DE VALIDACAO -->
        </div>
      </div>

      <!-- INFORMACOES COMPLEMENTARES DO PEDIDO -->
      <label-title title="Informações Adicionais" icon="fa-info-circle"></label-title>
      <div class="row">
        <div class="col-12">
          <v-button class="mb-3" label="Alterar Informações Adicionais" title="" :nb-btdef="false"
            @click="handleInfAdicionais"></v-button>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.finalidade"></v-label>
          <div class="lbl">{{ textOption(pedv.finalidade, metadata.pedv.finalidade) }}</div>
        </div>
        <div v-if="pedv.prazodias" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.prazodias"></v-label>
          <div class="lbl">{{ pedv.prazodias }}</div>
        </div>
        <div v-if="pedv.prazo" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.prazo"></v-label>
          <div class="lbl">{{ pedv.prazo | formatData }}</div>
        </div>
        <div v-if="pedv.validadedias" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.validadedias"></v-label>
          <div class="lbl">{{ pedv.validadedias }}</div>
        </div>
        <div v-if="pedv.dtvalidade" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.dtvalidade"></v-label>
          <div class="lbl">{{ pedv.dtvalidade | formatData }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.pedcli"></v-label>
          <div class="lbl">{{ pedv.pedcli }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.codtabpre"></v-label>
          <div class="lbl" v-if="pedv.tabpre && pedv.tabpre.length">{{ pedv.tabpre[0].descricao }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.tpfrete"></v-label>
          <div class="lbl">{{ textOption(pedv.tpfrete, metadata.pedv.tpfrete) }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.codparttr"></v-label>
          <div class="lbl" v-if="pedv.parttr && pedv.parttr.length">{{ pedv.parttr[0].nome }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.pliq"></v-label>
          <div class="lbl">{{ pedv.pliq | formatValue(2) }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.pbru"></v-label>
          <div class="lbl">{{ pedv.pbru | formatValue(2) }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.qtvolumes"></v-label>
          <div class="lbl">{{ pedv.qtvolumes }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.seqcontato"></v-label>
          <div class="lbl" v-if="pedv.contato && pedv.contato.length">{{ pedv.contato[0].nomecontato }}</div>
        </div>
        <div class="col-md-12 col-12">
          <v-label class="w-100" :metadata-field="metadata.pedv.endeent"></v-label>
          <div class="lbl">{{ pedv.endeent }} {{ pedv.endenrent }} {{ pedv.bairroent }} {{ pedv.ufent }}</div>
        </div>
      </div>
      <label-title v-if="pedv.historico_status" title="Histório Status" icon="fa-list"></label-title>
      <div v-if="pedv.historico_status" class="row">
        <div class="col-12">
          <ul class="timeline">
            <li>
              <span class="card-text">Pedido Realizado</span><br>
              <span class="card-text">{{ pedv.data | formatDataHoraExtenso }}</span>
            </li>
            <li v-for="(hist, index) in pedv.historico_status" :key="index">
              <span class="card-text">{{ hist.descricao }}</span><br>
              <span class="card-text">{{ hist.data | formatDataHoraExtenso }}</span>
              <p>{{ hist.obs }}</p>
            </li>
          </ul>
        </div>
      </div>

    </div>
    <!-- FIM FORMULARIO PRINCIPAL DO PEDIDO -->


    <!-- BARRA FIXA DE BOTOES INFERIOR -->
    <div class="w-100 text-center" v-show="btTotalizar || pedv.stpedv === 'P'"
      style="position: fixed; left: 0; bottom: 0; z-index: 10; border-top: 1px solid #eee; background-color: #fdfbfb; padding: 15px; -webkit-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); -moz-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); box-shadow: 0 -2px 5px rgba(0,0,0,0.2);">
      <v-button v-show="btTotalizar" tabindex="1" label="Finalizar Digitação de Produtos" :nb-btdef="true"
        title="Efetua a totalização do pedido e encerra a digitação" icon="" @click="handleTotalizar()"></v-button>
      <div v-show="pedv.stpedv === 'P'">
        <v-button v-if="botaoGerarPedido" label="Gerar Pedido" icon="" title="" :nb-btdef="true"
          @click="handleGerarPedido()"></v-button>
        <v-button label="Salvar e Fechar" v-if="!isView" title="" :nb-btdef="true" @click="handleTotalizar(true)">
        </v-button>
        <v-button label="Imprimir" icon="fa-print" v-show="btImprimir" :nb-btdef="false" @click="handleAction(1)">
        </v-button>
        <v-button label="Enviar" icon="fa-envelope-open" v-show="btEnviar" :nb-btdef="false" @click="handleEmail()">
        </v-button>
        <v-button v-if="botaoPerdido" label="Orçamento Perdido" icon="" title="" :danger="true"
          @click="handleOrcamentoPedido()"></v-button>
        <v-button v-show="btFaturar" label="Faturar Pedido" icon="fa-dollar" title="" :success="true"
          @click="handleFaturar()"></v-button>
      </div>
    </div>
    <!-- FIM BARRA FIXA DE BOTOES INFERIOR -->


    <!-- MENSAGEM PARA CANCELAR ITEM DO PEDIDO -->
    <md-message v-if="CANCEL_ITEM_MESSAGE" code="cancelit" @close="handleCloseMessage()" @confirm="handleItemCancel()">
    </md-message>

    <!-- MENSAGEM PARA REMOVER ITEM DO PEDIDO -->
    <md-message v-if="DELETE_ITEM_MESSAGE" code="deleteit" @close="handleCloseMessage()" @confirm="handleItemDelete()">
    </md-message>

    <!-- MENSAGEM PARA CANCELAMENTO DO PEDIDO -->
    <md-message v-if="CANCEL_MESSAGE" code="cancelpedv" @close="handleCloseMessage()" @confirm="handleCancel()">
    </md-message>

    <!-- MENSAGEM LINK CIELO -->
    <md-message v-if="CIELO_SL_MESSAGE" title="Link de pagamento Cielo" :message="cielo_sl_link"
      @close="handleCloseMessage()" @confirm="handleCloseMessage()"></md-message>


    <!-- TELA MODAL DE INCLUSAO/ALTERACAO DE ITEM DO PEDIDO -->
    <pedido-additem v-if="showFormItem" :params="{ pedv: pedv, pedvit: pedvit_update }" :view="formItemView"
      @closeform="closeFormItem" @save="handleSalvarItens"></pedido-additem>
    <!-- FIM TELA MODAL DE INCLUSAO/ALTERACAO DE ITEM DO PEDIDO -->

    <!-- TELA MODAL DE INFORMACOES COMPLEMENTARES -->
    <pedido-form-infcpl v-if="showFormInfAd" :is-view="isView" :metadata="metadata" :pedv="pedv"
      :partCodTabpre="partCodTabpre" @closeform="closeFormItem" @save="handleSaveCab"></pedido-form-infcpl>
    <!-- FIM TELA MODAL DE INFORMACOES COMPLEMENTARES -->


    <!-- MODAL CONTATOS WHATSAPP -->
    <fones-part-share v-if="showContatosWhats" :codpart="pedv.codpart" @closeform="handleWhatsapp"></fones-part-share>


    <!-- CADASTRO DO CONTATO -->
    <div v-if="showContatoForm">
      <customer-contato-form crud="ins" :codpart="pedv.codpart" @closeform="closeContatoForm"></customer-contato-form>
    </div>
    <!-- FIM CADASTRO DO CONTATO -->

    <!-- CADASTRO DE PARTICIPANTE/TRANSPORTADORA -->
    <div class="nb-modal-scrollable" v-if="showPartForm">
      <div class="container nb-modal-scrollable-container">
        <div class="nb-modal-scrollable-body">
          <customer-form crud="ins" @closeform="closePartForm" :transportadora="true"></customer-form>
        </div>
      </div>
    </div>
    <!-- FIM CADASTRO DE PARTICIPANTE/TRANSPORTADORA -->

    <!-- CADASTRO DE NATUREZA -->
    <div class="nb-modal-scrollable" v-if="showNatesForm">
      <div class="container nb-modal-scrollable-container">
        <div class="nb-modal-scrollable-body">
          <nates-form crud="ins" @closeform="closeNatesForm"></nates-form>
        </div>
      </div>
    </div>
    <!-- FIM CADASTRO DE NATUREZA -->

    <!-- ENVIO DE EMAIL -->
    <email-form v-if="showFormEmail" :index="pedv.codpedv" tipo="PEDV" title="Envio de Pedido"
      @closeform="closeFormEmail" @send="handleSendEmail"></email-form>
    <!-- FIM ENVIO DE EMAIL -->

    <!-- ENVIO DE EMAIL cielo super link -->
    <email-form v-if="showFormEmailCieloSL" :index="pedv.codpedv" tipo="CIELOSUPERLINK"
      title="Envio de Link para pagamento" @closeform="closeFormEmail" @send="handleSendEmail"></email-form>
    <!-- FIM ENVIO DE EMAIL cielo super link -->

    <div style="display: none">
      <PedidoImpressao ref="impressao" v-if="showImpressao" :index="codpedvImpressao" @close="handleClosePrint" />
    </div>
  </div>
</template>

<style scoped>
.dropdown-total {
  z-index: 1051;
  margin-top: 3px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
  padding: 10px;
  z-index: 1000;
  min-width: 200px;
  list-style: none;
  background-color: #fff;
  border: 1px solid #00000033;
  box-shadow: 0 5px 10px #00000033;
  background-clip: padding-box;
}
</style>



// WEBPACK FOOTER //
// src/forms-fv/fv-pedido-form.vue